import { ReturnUser } from './components/hpReturnUser';
import { StoriesModal } from './components/storiesModal';
import { ResearchFilter } from './components/researchFilter';
import { ListReadMore } from './components/listReadMore';
import { Animations } from './components/animations';

export function BSD() {

	ReturnUser();

	StoriesModal();

	ResearchFilter();

	ListReadMore();

	Animations();

}
